export const PAYMENT_PROVIDER_SWITCH_KEYS = {
	click: 'click',
	payme: 'payme',
	uzum: 'uzum',
	anor: 'anor',
	uzqr: 'uzqr',
}

export const PAYMENT_PROVIDER_FORM_SWITCH_KEYS = {
	[PAYMENT_PROVIDER_SWITCH_KEYS.click]: 'click',
	[PAYMENT_PROVIDER_SWITCH_KEYS.payme]: 'pay_me',
	[PAYMENT_PROVIDER_SWITCH_KEYS.uzum]: 'apelsin',
	[PAYMENT_PROVIDER_SWITCH_KEYS.anor]: 'anor',
	[PAYMENT_PROVIDER_SWITCH_KEYS.uzqr]: 'uzqr',
}

export const PAYMENT_PROVIDER_CREDENTIAL_GROUPS = {
	[PAYMENT_PROVIDER_SWITCH_KEYS.click]: [
		[
			'click_pass_service_id',
			'click_pass_merchant_user_id',
			'click_pass_secret_key',
		],
		[
			'click_qr_pay_service_id',
			'click_qr_pay_merchant_user_id',
			'click_qr_pay_secret_key',
		],
	],
	[PAYMENT_PROVIDER_SWITCH_KEYS.payme]: [
		['payme_subscribe_id', 'payme_subscribe_token'],
		[
			'payme_merchant_id',
			'payme_merchant_token',
			'payme_merchant_test_token',
		],
	],
	[PAYMENT_PROVIDER_SWITCH_KEYS.uzum]: [
		[
			'apelsin_merchant_id',
			'apelsin_merchant_user_id',
			'apelsin_merchant_service_id',
			'apelsin_merchant_secret_key',
		],
	],
	[PAYMENT_PROVIDER_SWITCH_KEYS.anor]: [
		['anor_secret_key', 'anor_branch_id'],
	],
	[PAYMENT_PROVIDER_SWITCH_KEYS.uzqr]: [
		['uzqr_api_key', 'uzqr_endpoint', 'uzqr_port'],
	],
}

export const isPaymentProviderFieldFilled = value => {
	if (value === null || value === undefined) return false
	if (typeof value === 'string') return value.trim() !== ''
	return Boolean(value)
}

export const isPaymentProviderCredentialGroupComplete = (data, fields) =>
	fields.every(field => isPaymentProviderFieldFilled(data?.[field]))

export const canEnablePaymentProvider = (switchKey, data) => {
	const credentialGroups = PAYMENT_PROVIDER_CREDENTIAL_GROUPS[switchKey]
	if (!credentialGroups?.length) return false

	return credentialGroups.some(group =>
		isPaymentProviderCredentialGroupComplete(data, group),
	)
}

export const getInvalidEnabledPaymentProviders = data =>
	Object.values(PAYMENT_PROVIDER_SWITCH_KEYS).filter(
		switchKey =>
			data?.[PAYMENT_PROVIDER_FORM_SWITCH_KEYS[switchKey]] &&
			!canEnablePaymentProvider(switchKey, data),
	)
